import GenericStateThreeBlock from './GenericStateThreeBlock';
import { GenericStateThreeBlockProps, GenericStateThreeBlockValueProps } from './types';

export type { GenericStateThreeBlockProps, GenericStateThreeBlockValueProps };
export default GenericStateThreeBlock;
